
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Twofiveseaterbus() {



    const cardData =
    {
        keyword: '25 Seater Tata Bus On Rent in Pune',
        heading: 'Amruta Travels: 25 Seater Tata Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers 25 Seater Tata Bus on Rent in Pune, ideal for small to medium-sized group travel with a focus on safety, affordability, and comfort. Whether you are planning a local city tour, family function, school picnic, or outstation trip, our well-maintained Tata buses ensure a smooth and enjoyable travel experience.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

  "services": [
    {
      "name": "25 Seater Tata Bus Hire in Pune",
      "description": "Amruta Travels offers 25-seater Tata buses for hire in Pune, perfect for mid-sized groups traveling for corporate events, weddings, or local and outstation trips with comfort and reliability."
    },
    {
      "name": "25 Seater Tata Bus Rental",
      "description": "Looking for a dependable rental option for group travel? Choose Amruta Travels’ 25-seater Tata bus rental service, featuring well-maintained buses with comfortable seating and professional drivers."
    },
    {
      "name": "Rent 25 Seater Tata Bus in Pune",
      "description": "Rent a 25-seater Tata bus in Pune for corporate, family, or educational trips. Amruta Travels ensures smooth journeys with AC options and experienced drivers for all your travel needs."
    },
    {
      "name": "25 Seater Tata Bus for Corporate Event",
      "description": "Make your corporate transportation seamless with a 25-seater Tata bus from Amruta Travels. Ideal for seminars, team outings, and conferences with punctual service and onboard comfort."
    },
    {
      "name": "25 Seater Tata Bus for Wedding in Pune",
      "description": "Ensure hassle-free guest transport for weddings with our 25-seater Tata buses. Amruta Travels offers timely, comfortable, and spacious transportation for wedding events in and around Pune."
    },
    {
      "name": "25 Seater Tata Bus for Picnic",
      "description": "Plan the perfect group outing or school picnic with our 25-seater Tata bus rentals. Amruta Travels offers reliable and safe transportation with roomy interiors and AC comfort."
    }
  ],
  "tableData": [
    ["25 Seater Tata Bus Hire in Pune", "25 Seater Tata Bus Rental"],
    ["Rent 25 Seater Tata Bus in Pune", "25 Seater Tata Bus for Corporate Event"],
    ["25 Seater Tata Bus for Wedding in Pune", "25 Seater Tata Bus for Picnic"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Reliable 25 Seater Tata Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers 25 Seater Tata buses on rent in Pune, ideal for medium-sized group travel. Whether it’s for a corporate trip, school excursion, wedding, or weekend getaway, our Tata buses provide dependable, budget-friendly, and comfortable travel solutions."
  },
  {
    "WhyChooseheading": "Perfect for Mid-Sized Group Travel and Local Events",
    "WhyChoosedescription": "The 25 Seater Tata bus is an excellent choice for family functions, corporate team outings, school picnics, or local tours. With spacious seating and essential amenities, your group can travel together efficiently and comfortably."
  },
  {
    "WhyChooseheading": "Air-Conditioned Comfort with Practical Amenities",
    "WhyChoosedescription": "Our 25 Seater Tata buses are equipped with effective air conditioning, cushioned pushback seats, wide windows, and sufficient legroom. These features make every journey—short or long—more enjoyable for all passengers."
  },
  {
    "WhyChooseheading": "Affordable Rates with Transparent Pricing",
    "WhyChoosedescription": "We provide clear and all-inclusive pricing for 25 Seater Tata bus rentals in Pune. No hidden charges—our rates include fuel, tolls, driver allowance, and taxes—making it easy to budget your trip without surprises."
  },
  {
    "WhyChooseheading": "Professional Drivers for Safe and Smooth Travel",
    "WhyChoosedescription": "Our drivers are experienced, licensed, and familiar with Pune city as well as outstation routes. They ensure your group reaches the destination safely and on time, while maintaining a courteous and professional attitude throughout the journey."
  },
  {
    "WhyChooseheading": "Ideal for Local and Short Outstation Trips",
    "WhyChoosedescription": "Whether it's a one-day picnic around Pune or a short outstation trip to places like Lonavala, Lavasa, or Shirdi, our 25 Seater Tata buses are perfect for travel plans that require comfort and reliability at an economical price."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for Stress-Free Travel",
    "WhyChoosedescription": "Our 25 Seater Tata buses are regularly inspected, cleaned, and maintained to the highest standards. We ensure every bus is road-ready and delivers a smooth, worry-free journey every time you travel with us."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a 25 Seater Tata bus with Amruta Travels is quick and simple. You can book online, call us, or visit our office. Our 24/7 customer service team is always available to assist with your travel needs, itinerary changes, and special requests."
  }
]















    }

const faqData = [
  {
    question: 'Can I rent a 25-seater Tata bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 25-seater Tata buses for rent in Pune. These buses are perfect for small to mid-sized groups traveling for events, excursions, corporate meetings, or outstation trips.',
  },
  {
    question: 'What amenities are available in the 25-seater Tata bus?',
    answer: 'Our 25-seater Tata buses are equipped with comfortable cushioned seats, air conditioning (optional), overhead storage, adequate legroom, and a clean interior to ensure a pleasant journey.',
  },
  {
    question: 'Is the 25-seater Tata bus available for both local and outstation travel?',
    answer: 'Yes, the 25-seater Tata bus is available for local city travel in Pune as well as long-distance outstation trips to destinations like Mumbai, Shirdi, Lonavala, Mahabaleshwar, and more.',
  },
  {
    question: 'Is a driver included in the Tata bus rental?',
    answer: 'Yes, all Tata bus rentals from Amruta Travels come with an experienced and licensed driver who ensures a safe, timely, and comfortable ride for all passengers.',
  },
  {
    question: 'How much does it cost to rent a 25-seater Tata bus in Pune?',
    answer: 'Rental charges vary based on distance, trip duration, and services required. Typically, rates start from ₹28–₹35 per km. Contact us with your itinerary for an accurate and customized quote.',
  },
  {
    question: 'Is the 25-seater Tata bus comfortable for long journeys?',
    answer: 'Yes, the 25-seater Tata bus is suitable for long journeys and is designed to provide a comfortable ride with sufficient space for passengers and luggage.',
  },
  {
    question: 'Are the 25-seater Tata buses well-maintained and sanitized?',
    answer: 'Absolutely. All our vehicles, including the 25-seater Tata bus, are routinely inspected, cleaned, and sanitized before each trip to ensure safety and hygiene.',
  },
  {
    question: 'How do I book a 25-seater Tata bus in Pune?',
    answer: 'You can easily book a 25-seater Tata bus online through our website or by contacting our customer support team. We offer quick booking assistance and transparent pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ajay Kulkarni',
    role: 'College Professor, Pune',
    text: 'We hired a 25-seater Tata bus from Amruta Travels for a college industrial visit. The bus was punctual, clean, and comfortable, and the service exceeded our expectations.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Nisha Gaikwad',
    role: 'Tour Organizer',
    text: 'I booked a 25-seater Tata bus for a weekend group tour to Lonavala. Amruta Travels provided great service, and the bus was in excellent condition. Highly recommended!',
    rating: 5,
  },
];






















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const tata25SeaterSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "25 Seater Tata Bus On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/25-seater-tata-bus.jpg", // Update this with the actual image URL
  "description": "Rent a 25-seater Tata bus in Pune for corporate events, weddings, picnics, and group travel. Comfortable and reliable bus rental services from Amruta Travels.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "80"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11000", // Adjust this based on your actual pricing
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/25-seater-tata-bus-on-rent-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 25 Seater Tata Bus On Rent in Pune | Wedding, Corporate & Picnic Bus Hire</title>
  <meta 
    name="description" 
    content="Rent a 25-seater Tata bus in Pune for corporate events, weddings, and picnics. Affordable and reliable Tata bus rental service with experienced drivers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(tata25SeaterSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Twofiveseaterbus;